import { lazy, Suspense, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Route, Routes } from "react-router-dom";
import PropTypes from "prop-types";
import Layout from "./jsx/layouts/layout";

import ProtectedRoute from "../src/jsx/components/ProtectedRoute";
import Error403 from "../src/jsx/pages/Error403";

import Index from "./jsx/index"; // Main App (Dashboard)
import { checkAutoLogin } from "./services/AuthService";
import { isAuthenticated } from "./store/selectors/AuthSelectors";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./assets/css/style.css";

import TokenSystem from "./jsx/components/AppsMenu/AppProfile/TokenSystem";
import TokenSystemMulti from "./jsx/components/AppsMenu/AppProfile/TokenSystemMulti";
import RegisterYourSelf from "./jsx/components/AppsMenu/AppProfile/RegisterYourSelf";
import PaymentReturnHandler from "./jsx/components/Common/PaymentReturnHandler";
import PaymentReturnTest from "./jsx/components/Common/PaymentReturnTest";
import PaymentSuccessPage from "./jsx/components/Common/PaymentSuccessPage";
import PaymentLinkPage from "./jsx/components/Common/PaymentLinkPage";
import AddForm from "./jsx/components/Questions/AddForm";
import VirtualId from "./jsx/components/AppsMenu/Patients/VirtualId/VirtualId";
import FormPreview from "./jsx/components/Questions/FormPreview";
import PatientForm from "./jsx/components/Questions/PatientForm";
import ConsentForm from "./jsx/components/Panchkarma/Form/ConsentForm";
import Patients from "./jsx/components/AppsMenu/Patients/Patients";
import Users from "./jsx/components/Users/Users";
import AddUser from "./jsx/components/Users/AddUser";
import Role from "./jsx/components/Users/Role";
import AddRole from "./jsx/components/Users/AddRole";
import Leads from "./jsx/components/AppsMenu/Patients/Leads";
import AddLead from "./jsx/components/AppsMenu/Patients/AddLead";
import AddPatients from "./jsx/components/AppsMenu/Patients/AddPatients";
import ImportLeads from "./jsx/components/AppsMenu/Patients/ImportLeads";
import Questions from "./jsx/components/Questions/Questions";
import AddQuestion from "./jsx/components/Questions/AddQuestion";
import Forms from "./jsx/components/Questions/Forms";
import Niyamavali from "./jsx/components/Master/Niyamavali"
import AddNiyamavali from "./jsx/components/Master/AddNiyamavali"
import Branch from "./jsx/components/Master/Branch";
import AddBranch from "./jsx/components/Master/AddBranch";
import Department from "./jsx/components/Master/Department";
import AddDepartment from "./jsx/components/Master/AddDepartment";
import Categories from "./jsx/components/Master/Categories";
import AddCategories from "./jsx/components/Master/AddCategories";
import Symptoms from "./jsx/components/Master/Symptoms";
import AddSymptom from "./jsx/components/Master/AddSymptom";
import AddDiseases from "./jsx/components/Master/AddDiseases";
import Disease from "./jsx/components/Master/Diseases";
import Medicine from "./jsx/components/Master/Medicine";
import AddMedicine from "./jsx/components/Master/AddMedicine";
import MedicineMapping from "./jsx/components/Master/MedicineMapping";
import AddMedicineMapping from "./jsx/components/Master/AddMedicineMapping";
import SymptomMedicineMapping from "./jsx/components/Master/SymptomMedicineMapping";
import AddSymptomMedicineMapping from "./jsx/components/Master/AddSymptomMedicineMapping";
import Doctor from "./jsx/components/Master/Doctors";
import AddDoctor from "./jsx/components/Master/AddDoctor";
import PatientsDetails from "./jsx/components/AppsMenu/Patients/PatientsDetails";
import ViewLead from "./jsx/components/AppsMenu/Patients/ViewLead";
import ReportUpload from "./jsx/components/AppsMenu/Patients/ReportUpload";
import Script from "./jsx/components/Master/Script";
import AddScript from "./jsx/components/Master/AddScript";
import AddObjection from "./jsx/components/Master/AddObjection";
import Objection from "./jsx/components/Master/Objection";
import PatientFormWrapper from "./jsx/components/Questions/PatientFormWrapper";
import MenopauseFormPage from "./jsx/components/AppsMenu/Patients/Components/MenopauseFormPage";
import GapldFormPage from "./jsx/components/AppsMenu/Patients/Components/GapldFormPage";
import MaleFormPage from "./jsx/components/AppsMenu/Patients/Components/MaleFormPage";
import PublicGapldForm from "./jsx/components/AppsMenu/Patients/Components/PublicGapldForm";
import AddNoteCategories from "./jsx/components/Master/AddNoteCategories";
import NoteCategories from "./jsx/components/Master/NoteCategories";
import AddDefaultDose from "./jsx/components/Master/AddDefaultDose";
import DefaultDose from "./jsx/components/Master/DefaultDose";
import AddFrequency from "./jsx/components/Master/AddFrequency";
import Frequency from "./jsx/components/Master/Frequency";
import HowToTake from "./jsx/components/Master/HowToTake";
import AddHowToTake from "./jsx/components/Master/AddHowToTake";
import AddUnitOfDose from "./jsx/components/Master/AddUnitOfDose";
import UnitOfDose from "./jsx/components/Master/UnitOfDose";
import AddAnupan from "./jsx/components/Master/AddAnupan";
import Anupan from "./jsx/components/Master/Anupan";
import MedicineType from "./jsx/components/Master/MedicineType";
import AddMedicineType from "./jsx/components/Master/AddMedicineType";
import Receptionist from "./jsx/components/Dashboard/Receptionist";
import Appointmentlist from "./jsx/components/Dashboard/Appoinmentlist";
import AddGST from "./jsx/components/Settings/AddGST";

import AddInwardStock from "./jsx/components/StockManagement/AddInwardStock";
import InwardStockList from "./jsx/components/StockManagement/InwardStock";
import StockTransactions from "./jsx/components/StockManagement/StockTransactions";
// import Receptionist from "./jsx/components/Dashboard/Receptionist";
// import Telecaller from "./jsx/components/Dashboard/Telecaller";
// import Receptionist from "./jsx/components/Dashboard/Receptionist";
// import Counsellor from "./jsx/components/Dashboard/Counsellor";
// import Medical from "./jsx/components/Dashboard/Medical";
// import ServiceCaller from "./jsx/components/Dashboard/ServiceCaller";
// Lazy-loaded pages
const Login = lazy(() => import("./jsx/pages/Login"));
const AppForgetPassword = lazy(() =>
  import("./jsx/components/AppsMenu/AppProfile/AppForgetPassword")
);
const CasePaper = lazy(() =>
  import("./jsx/components/AppsMenu/AppProfile/CasePaper")
);
const Gpldaform = lazy(() => import("./jsx/components/AppsMenu/Patients/Components/GpldaForm"));
/**
 * @param {{ isAuthenticated: boolean }} props
 */
function App({ isAuthenticated }) {
  const dispatch = useDispatch();
  useEffect(() => {
    // Apply restrictions ONLY on staging environments
    const isStaging = window.location.hostname.includes("-stage");

    if (!isStaging) return; // Skip restrictions for local, dev, UI, etc.

    const handleContextMenu = (e) => e.preventDefault();
    const handleCopy = (e) => {
      e.preventDefault();
      alert("Copying is disabled on this page.");
    };
    const handlePaste = (e) => e.preventDefault();
    const handleCut = (e) => e.preventDefault();

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("copy", handleCopy);
    document.addEventListener("paste", handlePaste);
    document.addEventListener("cut", handleCut);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("copy", handleCopy);
      document.removeEventListener("paste", handlePaste);
      document.removeEventListener("cut", handleCut);
    };
  }, []);

  useEffect(() => {
    // Only check auto login if not already on Token System
    if (!window.location.pathname.startsWith("/token-system") && !window.location.pathname.startsWith("/pay")) {
      checkAutoLogin(dispatch);
    }
  }, [dispatch]);

  const loader = (
    <div id="preloader">
      <div className="sk-three-bounce">
        <div className="sk-child sk-bounce1"></div>
        <div className="sk-child sk-bounce2"></div>
        <div className="sk-child sk-bounce3"></div>
      </div>
    </div>
  );

  if (window.location.pathname === "/token-system-multi") {
    return (
      <Suspense fallback={loader}>
        <TokenSystemMulti />
      </Suspense>
    );
  }
  // If directly opening token-system page
  if (window.location.pathname.startsWith("/token-system")) {
    return (
      <Suspense fallback={loader}>
        <TokenSystem />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={loader}>
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {isAuthenticated ? (
        <Routes>
          {/* Public route for report upload - with optional doctorId */}
          <Route
            path="/reports/upload/:patientId/:doctorId?"
            element={<ReportUpload />}
          />
          <Route path="/public/gapld-form" element={<PublicGapldForm />} />
          <Route path="/public/gplda-form" element={<Gpldaform />} />
          <Route
            path="/case-paper/:patientId?"
            element={
              <ProtectedRoute>
                <CasePaper />
              </ProtectedRoute>
            }
          />
          <Route path="/token-system" element={<TokenSystem />} />
          <Route path="/token-system-multi" element={<TokenSystemMulti />} />
          <Route path="/register-yourself" element={<RegisterYourSelf />} />
          <Route path="*" element={<Index />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            {/* <Route path="/telecaller" element={<ProtectedRoute><Telecaller /></ProtectedRoute>} /> */}
            <Route path="/receptionist" element={<ProtectedRoute><Receptionist /></ProtectedRoute>} />
            {/* <Route path="/counsellor" element={<ProtectedRoute><Counsellor /></ProtectedRoute>} /> */}
            {/* <Route path="/medical" element={<ProtectedRoute><Medical /></ProtectedRoute>} /> */}
            {/* <Route path="/service-caller" element={<ProtectedRoute><ServiceCaller /></ProtectedRoute>} /> */}

            <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <Users />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-user/edit_admin_id"
              element={
                <ProtectedRoute>
                  <AddUser />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-user"
              element={
                <ProtectedRoute>
                  <AddUser />
                </ProtectedRoute>
              }
            />

            <Route
              path="/roles"
              element={
                <ProtectedRoute>
                  <Role />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-role/role_id"
              element={
                <ProtectedRoute>
                  <AddRole />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-role"
              element={
                <ProtectedRoute>
                  <AddRole />
                </ProtectedRoute>
              }
            />

            <Route
              path="/app-lead-details"
              element={
                <ProtectedRoute>
                  <ViewLead />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app-add-lead"
              element={
                <ProtectedRoute>
                  <AddLead />
                </ProtectedRoute>
              }
            />

            <Route
              path="/app-update-lead"
              element={
                <ProtectedRoute>
                  <AddLead />
                </ProtectedRoute>
              }
            />

            <Route
              path="/app-patients"
              element={
                <ProtectedRoute>
                  <Patients />
                </ProtectedRoute>
              }
            />
            <Route
              path="/patients/add-patient"
              element={
                <ProtectedRoute>
                  <AddPatients />
                </ProtectedRoute>
              }
            />
            <Route
              path="/patients/update-patient/:id"
              element={
                <ProtectedRoute>
                  <AddPatients />
                </ProtectedRoute>
              }
            />

            <Route
              path="/patients/patient-details/:patientId"
              element={
                <ProtectedRoute>
                  <PatientsDetails />
                </ProtectedRoute>
              }
            />
            <Route path="/report-upload" element={<ReportUpload />} />

            <Route
              path="/app-import-leads"
              element={
                <ProtectedRoute>
                  <ImportLeads />
                </ProtectedRoute>
              }
            />

            <Route
              path="/questions"
              element={
                <ProtectedRoute>
                  <Questions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-question"
              element={
                <ProtectedRoute>
                  <AddQuestion />
                </ProtectedRoute>
              }
            />

            <Route
              path="/forms"
              element={
                <ProtectedRoute>
                  <Forms />
                </ProtectedRoute>
              }
            />
            <Route
              path="/forms/create-form"
              element={
                <ProtectedRoute>
                  <AddForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/forms/edit-form/form_id"
              element={
                <ProtectedRoute>
                  <AddForm />
                </ProtectedRoute>
              }
            />
            <Route path="/niyamavali" element={<Niyamavali />} />
            <Route path="/add-niyamavali" element={<AddNiyamavali />} />
            <Route path="/edit-niyamavali/:id" element={<AddNiyamavali />} />
            <Route
              path="/branches"
              element={
                <ProtectedRoute>
                  <Branch />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-branch"
              element={
                <ProtectedRoute>
                  <AddBranch />
                </ProtectedRoute>
              }
            />

            <Route
              path="/departments"
              element={
                <ProtectedRoute>
                  <Department />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-department"
              element={
                <ProtectedRoute>
                  <AddDepartment />
                </ProtectedRoute>
              }
            />

            <Route
              path="/categories"
              element={
                <ProtectedRoute>
                  <Categories />
                </ProtectedRoute>
              }
            />
            <Route
              path="/categories/update-category/category_id"
              element={
                <ProtectedRoute>
                  <AddCategories />
                </ProtectedRoute>
              }
            />
            <Route
              path="/categories/add-categories"
              element={
                <ProtectedRoute>
                  <AddCategories />
                </ProtectedRoute>
              }
            />

            <Route
              path="/symptoms"
              element={
                <ProtectedRoute>
                  <Symptoms />
                </ProtectedRoute>
              }
            />
            <Route
              path="/symptoms/update-symptom/symptom_id"
              element={
                <ProtectedRoute>
                  <AddSymptom />
                </ProtectedRoute>
              }
            />
            <Route
              path="/symptoms/add-symptom"
              element={
                <ProtectedRoute>
                  <AddSymptom />
                </ProtectedRoute>
              }
            />

            <Route
              path="/diseases"
              element={
                <ProtectedRoute>
                  <Disease />
                </ProtectedRoute>
              }
            />
            <Route
              path="/diseases/update-diseases/disease_id"
              element={
                <ProtectedRoute>
                  <AddDiseases />
                </ProtectedRoute>
              }
            />
            <Route
              path="/diseases/add-diseases"
              element={
                <ProtectedRoute>
                  <AddDiseases />
                </ProtectedRoute>
              }
            />

            <Route
              path="/medicines"
              element={
                <ProtectedRoute>
                  <Medicine />
                </ProtectedRoute>
              }
            />
            <Route
              path="/medicine/update-medicine/medicine_id"
              element={
                <ProtectedRoute>
                  <AddMedicine />
                </ProtectedRoute>
              }
            />
            <Route
              path="/medicine/add-medicine"
              element={
                <ProtectedRoute>
                  <AddMedicine />
                </ProtectedRoute>
              }
            />

            <Route
              path="/disease-medicine-mapping"
              element={
                <ProtectedRoute>
                  <MedicineMapping />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-medicinemapping"
              element={
                <ProtectedRoute>
                  <AddMedicineMapping />
                </ProtectedRoute>
              }
            />

            <Route
              path="/doctors"
              element={
                <ProtectedRoute>
                  <Doctor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-doctor"
              element={
                <ProtectedRoute>
                  <AddDoctor />
                </ProtectedRoute>
              }
            />

            <Route
              path="/scripts"
              element={
                <ProtectedRoute>
                  <Script />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-script"
              element={
                <ProtectedRoute>
                  <AddScript />
                </ProtectedRoute>
              }
            />
            <Route
              path="/objections"
              element={
                <ProtectedRoute>
                  <Objection />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-objection"
              element={
                <ProtectedRoute>
                  <AddObjection />
                </ProtectedRoute>
              }
            />
            <Route
              path="/note-categories"
              element={
                <ProtectedRoute>
                  <NoteCategories />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-note-category"
              element={
                <ProtectedRoute>
                  <AddNoteCategories />
                </ProtectedRoute>
              }
            />

            <Route
              path="/update-doctor"
              element={
                <ProtectedRoute>
                  <AddDoctor />
                </ProtectedRoute>
              }
            />

            <Route
              path="/symptom-medicine-mapping"
              element={
                <ProtectedRoute>
                  <SymptomMedicineMapping />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app-add-default-dose"
              element={
                <ProtectedRoute>
                  <AddDefaultDose />
                </ProtectedRoute>
              }
            />

            <Route
              path="/default-dose"
              element={
                <ProtectedRoute>
                  <DefaultDose />
                </ProtectedRoute>
              }
            />

            <Route
              path="/add-unit-of-dose"
              element={
                <ProtectedRoute>
                  <AddUnitOfDose />
                </ProtectedRoute>
              }
            />

            <Route
              path="/app-unit-of-dose"
              element={
                <ProtectedRoute>
                  <UnitOfDose />
                </ProtectedRoute>
              }
            />

            <Route
              path="/add-how-to-take"
              element={
                <ProtectedRoute>
                  <AddHowToTake />
                </ProtectedRoute>
              }
            />

            <Route
              path="/app-how-to-take"
              element={
                <ProtectedRoute>
                  <HowToTake />
                </ProtectedRoute>
              }
            />

            <Route
              path="/add-frequency"
              element={
                <ProtectedRoute>
                  <AddFrequency />
                </ProtectedRoute>
              }
            />

            <Route
              path="/frequency"
              element={
                <ProtectedRoute>
                  <Frequency />
                </ProtectedRoute>
              }
            />

            <Route
              path="/app-add-anupan"
              element={
                <ProtectedRoute>
                  <AddAnupan />
                </ProtectedRoute>
              }
            />

            <Route
              path="/app-anupan"
              element={
                <ProtectedRoute>
                  <Anupan />
                </ProtectedRoute>
              }
            />

            <Route path="/medicine-types" element={<MedicineType />} />
            <Route path="/add-medicine-type" element={<AddMedicineType />} />

            <Route
              path="/add-gst"
              element={
                <ProtectedRoute>
                  <AddGST />
                </ProtectedRoute>
              }
            />

            <Route path="/inward-stock" element={<InwardStockList />} />
            <Route path="/app-add-inward-stock" element={<AddInwardStock />} />
            <Route path="/stock-transactions" element={<StockTransactions />} />

            {/* <Route
              path="/add-symptommedicinemapping"
              element={
                <ProtectedRoute>
                  <AddSymptomMedicineMapping />
                </ProtectedRoute>
              }
            /> */}
          </Route>
          {/* All other authenticated routes */}
          <Route path="/unauthorized" element={<Error403 />} />
        </Routes>
      ) : (
        <div className="vh-100">
          <Routes>
            {/* Public payment routes - accessible without authentication */}
            {/* Public payment routes - accessible regardless of authentication */}
            {/* <Route path="/payment/return" element={<PaymentReturnHandler />} />
            <Route path="/payment/cancel" element={<PaymentReturnHandler />} />
            <Route path="/payment/test" element={<PaymentReturnTest />} />
            <Route path="/payment/link/:linkId" element={<PaymentLinkPage />} />
            <Route path="/pay/link/:linkId" element={<PaymentLinkPage />} />
            <Route path="/pay/:linkId" element={<PaymentLinkPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} /> */}
            <Route path="/payment/return" element={<PaymentReturnHandler />} />
            <Route path="/payment/cancel" element={<PaymentReturnHandler />} />
            <Route
              path="/payment/test"
              element={<div>Payment Test Route Working!</div>}
            />
            <Route path="/payment/link/:linkId" element={<PaymentLinkPage />} />
            <Route path="/pay/link/:linkId" element={<PaymentLinkPage />} />
            <Route path="/pay/:linkId" element={<PaymentLinkPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />

            {/* Public route for report upload - with optional doctorId */}
            <Route
              path="/reports/upload/:patientId/:doctorId?"
              element={<ReportUpload />}
            />
            <Route path="/patient/:patientId/menopause-form" element={<MenopauseFormPage />} />
            <Route path="/patient/:patientId/gapld-form" element={<GapldFormPage />} />
            <Route path="/patient/:patientId/male-form" element={<MaleFormPage />} />


            <Route path="/login" element={<Login />} />
            <Route
              path="/app-forget-password"
              element={<AppForgetPassword />}
            />
            <Route path="/token-system" element={<TokenSystem />} />
            <Route path="/token-system-multi" element={<TokenSystemMulti />} />
            <Route path="/public/gplda-form" element={<Gpldaform />} />
            <Route path="/register-yourself" element={<RegisterYourSelf />} />
            <Route path="/patient-id/:patientId" element={<VirtualId />} />
            {/* Add both PatientForm routes here */}
            {/* <Route path="/patient-id/:patientId" element={<PatientFormWrapper />} /> */}
            <Route
              path="/forms/consent/:formId/:patientId"
              element={<ConsentForm />}
            />
            <Route
              path="/forms/patient-form/:formId/:patientId"
              element={<PatientFormWrapper />}
            />
            <Route
              path="/forms/patient-form/:formId"
              element={<PatientForm />}
            />

            <Route path="*" element={<Login />} />
          </Routes>
        </div>
      )}
    </Suspense>
  );
}

App.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: isAuthenticated(state),
});

export default connect(mapStateToProps)(App);
